import React from 'react';
import Login from '../components/login.js';
import { Helmet } from "react-helmet-async";


const LoginPage = () => {
    return (
        <div className='login-page top-margin'>
            <Helmet>
                <title>Login | Acesse sua Conta no Revisa Já Aposentadoria</title>
                <meta
                name="description"
                content="Acesse sua conta para acompanhar sua solicitação de revisão de aposentadoria e envio de documentos."
                />
                <meta
                name="keywords"
                content="login revisão de aposentadoria, acessar conta INSS, revisão de benefício INSS, revisão aposentadoria login"
                />
                <meta property="og:title" content="Login - Revisa Já Aposentadoria" />
                <meta
                property="og:description"
                content="Entre na sua conta para acompanhar o processo de revisão da sua aposentadoria com segurança."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://revisajaaposentadoria.com.br/login" />
                <meta property="og:image" content="https://revisajaaposentadoria.com.br/og-login.png" />

                <link rel="canonical" href="https://revisajaaposentadoria.com.br/login" />
            </Helmet>
            <Login />
        </div>
    );
};



export default LoginPage;